import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://pos-dev-api.optwaves.com/api',
  appName: 'Optwaves POS - Dev',
  version: '1.0.0-dev',
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'si', 'ta'],
  currency: {
    code: 'LKR',
    symbol: 'Rs.',
    decimal: 2,
  },
  features: {
    offlineMode: true,
    multiLanguage: true,
    hardwareIntegration: true,
    analytics: true,
  },
  stripe: {
    publicKey: 'pk_test_your_stripe_public_key',
  },
  googleClientId:
    '34196693129-0eean4mkj9155g1fj2jfgkiko9atvagu.apps.googleusercontent.com',
  googleClientScriptUrl: 'https://accounts.google.com/gsi/client',
  googleClientScriptFallback: '/assets/google/gsi-client.js',
};
